export class BrandIDReq{
    brandId:number;
}